var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223",
    transform: "translate(-258.6 -527)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 68,
    height: 68,
    transform: "translate(258.6 527)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-phone-alt",
    "data-name": "Icon awesome-phone-alt",
    d: "M52.548,38.223,40.715,33.152a2.536,2.536,0,0,0-2.958.729l-5.24,6.4A39.159,39.159,0,0,1,13.8,21.563l6.4-5.24a2.529,2.529,0,0,0,.729-2.958L15.858,1.533A2.552,2.552,0,0,0,12.952.064L1.965,2.6A2.536,2.536,0,0,0,0,5.071a49.015,49.015,0,0,0,49.02,49.02,2.536,2.536,0,0,0,2.472-1.965l2.536-10.987a2.566,2.566,0,0,0-1.48-2.916Z",
    transform: "translate(265.555 533.954)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneLogo);
export default __webpack_public_path__ + "static/media/phoneLogo.b80f2183a7c2be20e32970fb0ca3f1a4.svg";
export { ForwardRef as ReactComponent };